var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 197 120.6",
    style: {
      enableBackground: "new 0 0 197 120.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.1344,
    y1: 25.1279,
    x2: 165.7204,
    y2: 146.7134,
    gradientTransform: "matrix(1 0 0 -1 0 143.2303)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9A20CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1341,
    style: {
      stopColor: "#9222CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3434,
    style: {
      stopColor: "#7C29D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6017,
    style: {
      stopColor: "#5833D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8964,
    style: {
      stopColor: "#2641D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9974,
    style: {
      stopColor: "#1346D6"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54,108C27.3,108,5.7,86.3,5.7,59.7S27.3,11.3,54,11.3c20.2,0,37.4,11.8,45.9,31.4L100,43 c4.7,11.4,21,41.2,40.3,42.1l17.5,0c4.4,0,9.1-2.5,9.1-8.1c0-6.7-7.6-7.1-9.1-7.1h-12.1c-14.9,0-27.9-14-27.9-30 c0-15.7,12.8-28.9,27.9-28.9h30.1c6.2,0,11.3,5.1,11.3,11.3c0,6.2-5.1,11.3-11.3,11.3h-30.1c-2.6,0-5.3,3.2-5.3,6.3 c0,3.5,3.1,7.3,5.3,7.3h12.2c18.1,0,31.8,12.8,31.8,29.7c0,17.2-13.9,30.7-31.8,30.7l-18.1,0c-16.4-0.6-32.2-10.9-45.7-29.7 c-9-12.5-14.2-24.8-14.8-26.4C76.1,45,69.1,34,54,34c-14.2,0-25.7,11.5-25.7,25.7S39.8,85.4,54,85.4c4.7,0,9.3-1.3,13.3-3.7 c5.3-3.2,12.3-1.5,15.5,3.8c3.2,5.3,1.5,12.3-3.8,15.5C71.5,105.6,62.8,108,54,108z M55.5,49.8c-5.5,0-10,4.5-10,10 c0,5.6,4.5,10.1,10,10.1s10-4.5,10-10.1C65.6,54.3,61.1,49.8,55.5,49.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsLogoIcon);
export default __webpack_public_path__ + "static/media/ASLogoIcon.df595d95d037f68986f1d6bfaaada429.svg";
export { ForwardRef as ReactComponent };